module.exports = __webpack_public_path__ + "img/machines.4b522d51.png";